/* @ngInject */
function RequestsTabController ($scope, $rootScope, $translate, $timeout, $q, TasksService, ToastService, WorkflowHeaderService, UserFilterService, UdsModalService, ConfirmationModalService) {
  const getSaveTaskFilterDialogController = () => $q.when(import('../../dialogs/save-task-filter/save-task-filter-dialog.controller'))

  $scope.options = {
    $sort: 'createdAt',
    $order: 'DESC',
    $top: 10,
    $skip: 0
  }

  $scope.items = []
  $scope.count = null

  $scope.loading = false
  $scope.loadingMore = false

  $scope.selectedQuickFilter = null
  $scope.selectedFilters = null

  let loadingRequests = true

  const api = {
    getSaveTaskFilterDialogController,
    _getRequests,
    _resetTabObject,
    _getRequestsStatus,
    _getRequestsFilters,
    _setIsFiltering,
    _getUserFilters,
    _clearAdvancedFilters,
    _openEditUserFilterDialog,
    _openDeleteUserFilterDialog,
    _getUserSelectedFilters,
    _getAdvancedSelectedFilters
  }
  this.getApi = () => api

  $translate.onReady(() => {
    $scope.sortOptions = [
      {
        label: $translate.instant('recents'),
        value: 'createdAt',
        active: true
      },
      {
        label: $translate.instant('status'),
        value: 'status'
      },
      {
        label: $translate.instant('briefing'),
        value: 'briefing'
      }
    ]

    $scope.userFilterOptions = [
      {
        id: 'EDIT',
        label: $translate.instant('edit'),
        value: 'EDIT',
        active: false
      },
      {
        id: 'DELETE',
        label: $translate.instant('delete'),
        value: 'DELETE',
        active: false
      }
    ]
  })

  activate()

  function activate () {
    $scope.filters = WorkflowHeaderService.getRequestsFilters($translate, $rootScope.oUser.locale)
    $scope.quickFilters = [
      {
        label: $translate.instant('toApprove'),
        value: 'WAITING_RESPONSE'
      },
      {
        label: $translate.instant('adjustmentsNeeded'),
        value: 'WAITING_USER_ADJUST'
      },
      {
        label: $translate.instant('rejecteds'),
        value: 'REJECTED'
      }
    ]
    $scope.selectedQuickFilter = $scope.filterOnLoad || $scope.quickFilters[0].value
    api._getUserFilters()
  }

  $scope.$watch('isTabSelected', (isTabSelected) => {
    if (isTabSelected) {
      api._resetTabObject()
      api._getRequests()
    }
  })

  $scope.onChangeSortOrder = () => {
    const sort = $scope.options.$sort
    const order = $scope.options.$order === 'ASC' ? 'DESC' : 'ASC'

    api._resetTabObject()

    $scope.options.$sort = sort
    $scope.options.$order = order

    api._getRequests()
  }

  $scope.onChangeSortSelect = (event) => {
    event.preventDefault()
    event.stopPropagation()
    const value = event?.detail?.value

    if (value) {
      api._resetTabObject()

      $scope.options.$sort = value

      api._getRequests()
    }
  }

  $scope.loadMoreRequests = () => {
    try {
      $scope.loadingMore = true
      $scope.options.$skip = $scope.options.$skip + $scope.options.$top
      api._getRequests()
    } catch (error) {
      console.error({ error })
      ToastService.defaultErrorToast()
    } finally {
      $timeout(() => {
        $scope.loadingMore = false
      }, 100)
    }
  }

  $scope.onFilter = (filters, hasPreFilters, filtersCount, ignoreSubmit) => {
    if (loadingRequests) {
      loadingRequests = false
      return
    }

    $scope.selectedFilters = filters
    if (ignoreSubmit) return

    $scope.selectedQuickFilter = null

    $('.filters-section uds-pill-select').attr('checked', false)

    api._resetTabObject()
    api._getRequests()
  }

  $scope.onQuickFilterClick = (value) => {
    if ($scope.selectedQuickFilter === value) {
      $scope.selectedQuickFilter = null
    } else {
      $scope.selectedQuickFilter = value
    }

    $('.filters-section uds-pill-select').attr('checked', false)

    api._clearAdvancedFilters()
    api._resetTabObject()
    api._getRequests()
  }

  $scope.onSaveFilter = (filters) => {
    api.getSaveTaskFilterDialogController().then(({ SaveTaskFilterDialogController }) => {
      const saveTaskFilterDialog = UdsModalService.createModal({
        controller: SaveTaskFilterDialogController,
        modalName: 'saveTaskFilterDialog',
        data: {
          selectedFilters: filters,
          allFilters: $scope.filters,
          location: 'requests'
        },
        onClose: (wasCreated) => {
          if (wasCreated) {
            api._getUserFilters()
          }
        }
      })

      saveTaskFilterDialog.open()
    })
  }

  $scope.onUserFilterOptionClick = (event, userFilter) => {
    const option = event.detail?.option?.value

    if (option === 'EDIT') {
      api._openEditUserFilterDialog(userFilter)
    } else if (option === 'DELETE') {
      api._openDeleteUserFilterDialog(userFilter)
    }
  }

  $scope.onUserFilterSelect = (event, userFilter) => {
    if (event.detail?.checked) {
      $scope.selectedQuickFilter = userFilter
    } else {
      $scope.selectedQuickFilter = null
    }

    $(`uds-pill-select:not(.user-filter-${userFilter.id})`).attr('checked', false)

    api._clearAdvancedFilters()
    api._resetTabObject()
    api._getRequests()
  }

  function _clearAdvancedFilters () {
    $scope.$broadcast('advancedSearch.clearAllFilters', true)
  }

  function _getRequests () {
    $scope.loading = true

    const status = api._getRequestsStatus()
    const filters = api._getRequestsFilters()

    api._setIsFiltering(filters, status)

    return TasksService.getRequests({
      $top: $scope.options.$top,
      $skip: $scope.options.$skip,
      $sort: $scope.options.$sort,
      $order: $scope.options.$order,
      status,
      filters
    }).then(result => {
      $scope.items.push(...result.rows)
      $scope.count = result.count
      $scope.tabCount = result.count
    }).finally(() => {
      $timeout(() => { $scope.loading = false })
    })
  }

  function _resetTabObject () {
    $scope.loading = false
    $scope.loadingMore = false
    $scope.items = []
    $scope.count = null
    $scope.options.$top = 10
    $scope.options.$skip = 0
    $scope.options.$sort = 'createdAt'
    $scope.options.$order = 'DESC'
  }

  function _getRequestsStatus () {
    const status = []

    if ($scope.selectedQuickFilter?.userId) {
      const statusItem = $scope.selectedQuickFilter.filterItems.find(item => item.filter === 'taskStatus')
      if (statusItem) {
        status.push(statusItem.value)
      }
    } else if ($scope.selectedQuickFilter) {
      status.push($scope.selectedQuickFilter)
    } else if ($scope.selectedFilters?.taskStatus) {
      status.push(...$scope.selectedFilters.taskStatus)
    }

    return status.length > 0 ? status : ''
  }

  function _getRequestsFilters () {
    if ($scope.selectedQuickFilter?.userId) {
      return api._getUserSelectedFilters()
    } else {
      return api._getAdvancedSelectedFilters()
    }
  }

  function _getUserSelectedFilters () {
    const filterObj = {}

    $scope.selectedQuickFilter.filterItems.forEach(item => {
      filterObj[item.filter] = item.value
    })

    return {
      authors: filterObj.authors || [],
      archived: filterObj.isArchived,
      briefings: filterObj.form || [],
      createdAtStart: filterObj.createdAtStart,
      createdAtEnd: filterObj.createdAtEnd,
      groups: filterObj.groups || []
    }
  }

  function _getAdvancedSelectedFilters () {
    const filters = {}

    if ($scope.selectedFilters?.authors) {
      filters.authors = $scope.selectedFilters.authors
    }

    if ($scope.selectedFilters?.createdAtStart && $scope.selectedFilters?.createdAtEnd) {
      filters.createdAtStart = $scope.selectedFilters.createdAtStart
      filters.createdAtEnd = $scope.selectedFilters.createdAtEnd
    }

    if ($scope.selectedFilters?.form) {
      filters.briefings = $scope.selectedFilters.form
    }

    if ($scope.selectedFilters?.isArchived) {
      filters.archived = $scope.selectedFilters.isArchived
    } else {
      filters.archived = false
    }

    return filters
  }

  function _setIsFiltering (filters, status) {
    const filteringActives = filters.archived === 'false' || filters.archived === false
    const filtersWithValue = UserFilterService.getFiltersWithValue(filters)
    const onlyOneFilter = filtersWithValue.length === 1 && status.length === 0
    $scope.isFiltering = !(onlyOneFilter && filteringActives)
  }

  function _getUserFilters () {
    UserFilterService.getUserFilters('requests').then(filters => {
      $scope.userFilters = filters

      if ($scope.userFilters.length && !$scope.filterOnLoad) {
        $scope.selectedQuickFilter = $scope.userFilters[0]

        const waitForElement = () => {
          const element = $(`uds-pill-select.user-filter-${$scope.selectedQuickFilter.id}`)
          if (element.length > 0) {
            element.attr('checked', true)
            api._resetTabObject()
            api._getRequests()
          } else {
            $timeout(waitForElement, 100)
          }
        }

        $scope.$evalAsync(waitForElement)
      }

      $scope.filterOnLoad = null
    })
  }

  function _openEditUserFilterDialog (userFilter) {
    api.getSaveTaskFilterDialogController().then(({ SaveTaskFilterDialogController }) => {
      const saveTaskFilterDialog = UdsModalService.createModal({
        controller: SaveTaskFilterDialogController,
        modalName: 'saveTaskFilterDialog',
        data: {
          selectedFilters: userFilter.filterItems,
          allFilters: $scope.filters,
          editMode: true,
          name: userFilter.name,
          userFilterId: userFilter.id
        },
        onClose: (wasUpdated) => {
          if (wasUpdated) {
            api._getUserFilters()
          }
        }
      })

      saveTaskFilterDialog.open()
    })
  }

  function _openDeleteUserFilterDialog (userFilter) {
    ConfirmationModalService.createModal({
      title: $translate.instant('deleteFilter.title'),
      description: $translate.instant('deleteFilter.description', { filterName: userFilter.name }),
      buttonCancelText: $translate.instant('no'),
      buttonConfirmText: $translate.instant('yesDelete'),
      onConfirm: () => {
        UserFilterService.deleteUserFilter(userFilter.id)
          .then(() => {
            api._getUserFilters()
            ToastService.showSuccessToast($translate.instant('deleteFilter.success', { filterName: userFilter.name }))
          })
          .catch(() => {
            ToastService.defaultErrorToast()
          })
      }
    })
  }
}

export { RequestsTabController }
